import React, { useEffect, useState } from "react";
import { Card, Col, Form } from "react-bootstrap";
import {
    GetResidualFileBase64,
    ResidualFileDelete,
    ResidualFileGet,
} from "../../../../api";
import SelectDropDown from "../../../shared/drop-down/drop-down";
import UploadFiles from "../../upload/upload";
import leftArrow from "../../../../../images/left-arrow.png";
import rightArrow from "../../../../../images/right-arrow.png";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Select from "react-select";
import ShowResidualPdfModal from "../../../modals/show-residual-pdf/show-residual-pdf";
import Loader from "../../../loader/loader";
const customStyles = {
    option: (provided, state) => ({
        ...provided,
        borderBottom: "1px solid #EAEBEF",
        padding: 10,
        fontSize: 12,
        color: "#58585B",
    }),
    control: () => ({
        width: "100%",
    }),
};
const ResidualList = ({
    ResidualArray,
    ResidualPdfData,
    organization_id,
    isPcAdmin,
    isAdmin,
    isAgent,
}) => {
    const [residualYears, setResidualYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
    const [residualData, setResidualData] = useState([]);
    const [showResidualSpinner, setShowResidualSpinner] = useState(false);
    const [docModalPdf, setDocModalPdf] = useState(false);
    const [docModalFile, setDocModalFile] = useState([]);
    const [residualPdfData, setResidualPdfData] = useState([]);
    const [residualDataArray, setResidualDataArray] = useState(ResidualArray);
    const [residualPdfArray, setResidualPdfArray] = useState(ResidualPdfData);
    const Months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];
    useEffect(() => {
        var max = new Date().getFullYear();
        setSelectedYear(new Date().getFullYear());
        var min = max - 15;
        var years = [];

        for (var i = max; i >= min; i--) {
            years.push({
                label: i,
                value: i,
            });
        }
        setResidualYears(years);
    }, []);
    useEffect(() => {
        const residualDataForYear = residualDataArray
            ? residualDataArray[selectedYear]
            : null;
        const residualPdfForYear = residualPdfArray
            ? residualPdfArray[selectedYear]
            : null;
        if (residualDataForYear && residualPdfForYear) {
            setResidualData(residualDataForYear);
            setResidualPdfData(residualPdfForYear);
        } else {
            updateResiduals();
        }
    }, [selectedYear]);

    const residualFileDownload = (month, year) => {
        const final_url =
            "/residuals-download/" +
            organization_id +
            "/" +
            year +
            "/" +
            Months[month] +
            "?time=" +
            Math.floor(Date.now() / 1000);
        const link = document.createElement("a");
        link.href = final_url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const openDocModal = (month, year) => {
        setShowResidualSpinner(true);
        GetResidualFileBase64({
            organization_id,
            month: Months[month],
            year,
        }).then((response) => {
            if (response.success) {
                setDocModalFile(response);
                setDocModalPdf(true);
                setShowResidualSpinner(false);
            } else {
                setShowResidualSpinner(false);
                setDocModalPdf(false);
                setDocModalFile([]);
            }
        });
    };

    const closeDocModal = () => {
        setDocModalPdf(false);
        setDocModalFile([]);
    };

    const populateLocalArray = (CurrentYear) => {
        var ResidualFinalArray = [];
        if (ResidualFinalArray[CurrentYear] === undefined) {
            ResidualFinalArray[CurrentYear] = [];
        }
        for (var i = 1; i <= 12; i++) {
            ResidualFinalArray[CurrentYear][i] = 0;
        }
        return ResidualFinalArray;
    };

    const residualFileDelete = (month, year) => {
        let data = {
            organization_id: organization_id,
            month: Months[month],
            year: year,
        };
        ResidualFileDelete(data)
            .then((response) => {
                updateResiduals();
            })
            .catch((error) => console.log(error));
    };

    const updateResiduals = () => {
        var ResidualFinalArray = [];
        var ResidualFinalPDFArray = [];
        const dataRes = {
            organization_id: organization_id,
            year: selectedYear,
        };
        ResidualFileGet(dataRes)
            .then((response) => {
                if (response.success) {
                    const residual_data = response.data;
                    if (residual_data.length == 0) {
                        ResidualFinalArray = populateLocalArray(selectedYear);
                        ResidualFinalPDFArray =
                            populateLocalArray(selectedYear);
                    } else {
                        residual_data.map((item) => {
                            if (ResidualFinalArray[item.year] === undefined) {
                                ResidualFinalArray[item.year] = [];
                            }
                            if (
                                ResidualFinalPDFArray[item.year] === undefined
                            ) {
                                ResidualFinalPDFArray[item.year] = [];
                            }
                            ResidualFinalArray[item.year][item.month] =
                                item.uploaded;
                            ResidualFinalPDFArray[item.year][item.month] =
                                item.converted_file ? 1 : 0;
                        });
                    }
                    const residualDataForYear =
                        ResidualFinalArray[selectedYear];
                    const residualPdfDataForYear =
                        ResidualFinalPDFArray[selectedYear];
                    setResidualData(residualDataForYear);
                    setResidualPdfData(residualPdfDataForYear);
                } else {
                    window.location.href = "/";
                }
            })
            .catch((error) => console.log(error));
    };

    const handleResidualDelete = (month, year) => {
        confirmAlert({
            title: "Delete Residual",
            message: "Are you sure you want to delete the residual?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => residualFileDelete(month, year),
                },
                {
                    label: "No",
                },
            ],
        });
    };

    const prevYear = () => {
        let year = selectedYear - 1;
        setSelectedYear(year);
        document.querySelector(
            '.customselectdropdown11 input[name="year"]',
        ).value = year;
        document.querySelector(
            ".customselectdropdown11 .css-dvua67-singleValue",
        ).textContent = year;
        document.querySelector(
            ".customselectdropdown11 .css-151xaom-placeholder",
        ).textContent = year;
    };
    const nextYear = () => {
        let year = selectedYear + 1;
        setSelectedYear(year);
        document.querySelector(
            '.customselectdropdown11 input[name="year"]',
        ).value = year;
        document.querySelector(
            ".customselectdropdown11 .css-dvua67-singleValue",
        ).textContent = year;
        document.querySelector(
            ".customselectdropdown11 .css-151xaom-placeholder",
        ).textContent = year;
    };
    return (
        <>
            <div className="col-md-12">
                <div className="monthselect">
                    {residualYears && residualYears.length > 0 && (
                        <Form.Group
                            className="px-3 mothslectpd"
                            as={Col}
                            xs={12}
                            lg={2}
                            controlId="year"
                        >
                            <span onClick={prevYear}>
                                <img src={leftArrow} alt="arrow-icons" />
                            </span>

                            <Select
                                name="year"
                                placeholder={selectedYear}
                                styles={customStyles}
                                onChange={(selectedOption) => {
                                    setSelectedYear(selectedOption.value);
                                }}
                                options={residualYears}
                                isSearchable={true}
                                className="custom-slect customselectdropdown11"
                            />

                            {selectedYear < new Date().getFullYear() && (
                                <span onClick={nextYear}>
                                    <img src={rightArrow} alt="arrow-icons" />
                                </span>
                            )}
                        </Form.Group>
                    )}
                </div>
            </div>
            <div className="col-md-12">
                {Months.map((month, index) => (
                    <div key={"month" + index} className="monthdiv">
                        <div className="col-md-2">
                            <div className="monthname">
                                <p>{month}</p>
                            </div>
                        </div>
                        {residualData[index + 1] !== 0 && (
                            <div className="col-md-9">
                                <div className="uploadDate">
                                    <div className="uplodPdf">
                                        <img src="/images/pdffile.svg" />{" "}
                                        <span>{month + ".xlsx"}</span>
                                    </div>
                                    <div className="dwanloadmaindiv">
                                        <div
                                            onClick={() =>
                                                residualFileDownload(
                                                    index,
                                                    selectedYear,
                                                )
                                            }
                                            className="dwnload"
                                        >
                                            <svg
                                                className="pointer"
                                                width="15"
                                                height="16"
                                                viewBox="0 0 15 16"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M0 14.4H14.4V16H0V14.4ZM8 6.4H13.6L7.2 12.8L0.8 6.4H6.4V0H8V6.4Z"
                                                    fill="#A7A8AD"
                                                />
                                            </svg>
                                        </div>
                                        {residualPdfData[index + 1] !== 0 && (
                                            <div
                                                onClick={() =>
                                                    openDocModal(
                                                        index,
                                                        selectedYear,
                                                    )
                                                }
                                                className="dwnload pointer"
                                            >
                                                <img src="/images/pdffile.svg" />
                                            </div>
                                        )}
                                        {isPcAdmin && (
                                            <div
                                                onClick={() =>
                                                    handleResidualDelete(
                                                        index,
                                                        selectedYear,
                                                    )
                                                }
                                                className="deledt pointer"
                                            >
                                                <img src="/images/delet.svg" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                        {residualData[index + 1] === 0 && isPcAdmin && (
                            <div className="col-md-9">
                                <div className="uploadDoc">
                                    <UploadFiles
                                        updateResiduals={() =>
                                            updateResiduals()
                                        }
                                        organization_id={organization_id}
                                        selectedYear={selectedYear}
                                        month={index}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {showResidualSpinner ? (
                <div className="spinner spinner_residual_pdf">
                    <Loader />
                </div>
            ) : (
                ""
            )}
            {docModalPdf ? (
                <ShowResidualPdfModal
                    isOpen={docModalPdf}
                    close={() => closeDocModal()}
                    file={docModalFile}
                    fileType={"pdf"}
                />
            ) : (
                ""
            )}
        </>
    );
};

export default ResidualList;
